import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './PastHistoryWrite.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import URL from "../../../../../constants/url";
import Modal from "../../../../../components/comm/Modal"
import { useLocation, useNavigate } from 'react-router-dom';
import ToastPopup from '../../../../../components/comm/ToastPopup';


const PastHistoryWrite = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    
    const location = useLocation();
    const navigate = useNavigate();
    const mediInfo = location.state?.mediInfo;

    const [isDisabled, setIsDisabled] = useState(true);

    const [saveMediInfo , setSaveMediInfo] = useState({
        id : mediInfo.id,
        usrInfoId : mediInfo.usrInfoId,
        cancrDgnssAt : mediInfo.cancrDgnssAt, //암
        dabtsDgnssAt : mediInfo.dabtsDgnssAt, //당뇨
        hhprsDgnssAt : mediInfo.hhprsDgnssAt, //고혈압
        tbrclDgnssAt : mediInfo.tbrclDgnssAt, //결핵
        hrtsDgnssAt : mediInfo.hrtsDgnssAt, //간염
        hypldDgnssAt : mediInfo.hypldDgnssAt, //이상고지혈증
    });
    const [saveCompleteOpen, setSaveCompleteOpen] = useState(false);  //저장완료 모달

    const handleChageText = (target) => {
        const { name, value } = target;

        setSaveMediInfo((prev) => ({ ...prev, [name]: value }));
    }

    const handleChangeRadio = (target) => {
        const { name, value } = target;
        setSaveMediInfo((prev) => ({ ...prev, [name]: value }));
    };

    const saveMediHlthInfo = useCallback(async () => {

        const url = "/mypage/saveMediHlthInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
        }

        await axiosApi.post(url, saveMediInfo, reqOptions)
        // await axiosApi.post(url, saveMediInfo)
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setSaveCompleteOpen(true);
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            console.error("내 의료정보 저장 중 오류 : ", err);
        })

    },[saveMediInfo])

    const handleClickSaveCompleteBtn = () => {
        setSaveCompleteOpen(false);
        navigate('/MyPageMain', { replace: true });
    }

    useEffect(() => {
                
        if(saveMediInfo.id === mediInfo.id &&
            saveMediInfo.usrInfoId === mediInfo.usrInfoId &&
            saveMediInfo.cancrDgnssAt === mediInfo.cancrDgnssAt && 
            saveMediInfo.dabtsDgnssAt === mediInfo.dabtsDgnssAt && 
            saveMediInfo.hhprsDgnssAt === mediInfo.hhprsDgnssAt && 
            saveMediInfo.tbrclDgnssAt === mediInfo.tbrclDgnssAt && 
            saveMediInfo.hrtsDgnssAt === mediInfo.hrtsDgnssAt && 
            saveMediInfo.hypldDgnssAt === mediInfo.hypldDgnssAt 
        ) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }

    },[saveMediInfo])

    if(!mediInfo) return;
    
    return (
        <>

            <HeadSub title="과거력"/>

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['record-writebox']}>

                        <div className={style['info-box']}>
                            <p>아래 질환에 대해 과거에 진단받은 적이 있는지 표시해 주세요. (해당 항목에 체크해 주시기 바랍니다.)</p>
                        </div>

                        <div className={style['select-list-box']}>
                            <p>암</p>
                            <span>예) 위암, 대장암, 유방암, 폐암, 간암 등</span>
                            <ul>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="cancrDgnssAt-select1" name='cancrDgnssAt' value={'1'} checked={saveMediInfo.cancrDgnssAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="cancrDgnssAt-select1">
                                            <span>있음</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="cancrDgnssAt-select2" name='cancrDgnssAt' value={'0'} checked={saveMediInfo.cancrDgnssAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="cancrDgnssAt-select2">
                                            <span>없음</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={style['select-list-box']}>
                            <p>당뇨</p>
                            <span>예) 제1형, 제2형 당뇨병</span>
                            <ul>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="dabtsDgnssAt-select1" name='dabtsDgnssAt' value={'1'} checked={saveMediInfo.dabtsDgnssAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="dabtsDgnssAt-select1">
                                            <span>있음</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="dabtsDgnssAt-select2" name='dabtsDgnssAt' value={'0'} checked={saveMediInfo.dabtsDgnssAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="dabtsDgnssAt-select2">
                                            <span>없음</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={style['select-list-box']}>
                            <p>고혈압</p>
                            <span>예) 본태성 고혈압, 2차성 고혈압</span>
                            <ul>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="hhprsDgnssAt-select1" name='hhprsDgnssAt' value={'1'} checked={saveMediInfo.hhprsDgnssAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="hhprsDgnssAt-select1">
                                            <span>있음</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="hhprsDgnssAt-select2" name='hhprsDgnssAt' value={'0'} checked={saveMediInfo.hhprsDgnssAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="hhprsDgnssAt-select2">
                                            <span>없음</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={style['select-list-box']}>
                            <p>결핵</p>
                            <span>예) 폐결핵, 잠복결핵, 과거 결핵치료 이력</span>
                            <ul>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="tbrclDgnssAt-select1" name='tbrclDgnssAt' value={'1'} checked={saveMediInfo.tbrclDgnssAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="tbrclDgnssAt-select1">
                                            <span>있음</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="tbrclDgnssAt-select2" name='tbrclDgnssAt' value={'0'} checked={saveMediInfo.tbrclDgnssAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="tbrclDgnssAt-select2">
                                            <span>없음</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={style['select-list-box']}>
                            <p>간염</p>
                            <span>예) A형, B형, C형 간염, 간병변 등</span>
                            <ul>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="hrtsDgnssAt-select1" name='hrtsDgnssAt' value={'1'} checked={saveMediInfo.hrtsDgnssAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="hrtsDgnssAt-select1">
                                            <span>있음</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="hrtsDgnssAt-select2" name='hrtsDgnssAt' value={'0'} checked={saveMediInfo.hrtsDgnssAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="hrtsDgnssAt-select2">
                                            <span>없음</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={style['select-list-box']}>
                            <p>이상지질혈증(고지혈증)</p>
                            {/* <span>%어쩌고 저쩌고 판단 기준 또는 질환 예시를 노출하는 영역 길어지면 줄바꿈 처리되어야 함%</span> */}
                            <ul>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="hypldDgnssAt-select1" name='hypldDgnssAt' value={'1'} checked={saveMediInfo.hypldDgnssAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="hypldDgnssAt-select1">
                                            <span>있음</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox' data-size="smd">
                                        <input type="radio" id="hypldDgnssAt-select2" name='hypldDgnssAt' value={'0'} checked={saveMediInfo.hypldDgnssAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="hypldDgnssAt-select2">
                                            <span>없음</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>



                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                            <div className="inner-box">

                                <div className='btn-layout' data-btn-num="1">
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={saveMediHlthInfo} disabled={isDisabled}>
                                        <span>수정 완료</span>
                                    </button>
                                </div>

                            </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
                <Modal isOpen={saveCompleteOpen} setIsOpen={handleClickSaveCompleteBtn}>
                    <div className='modal-box' data-type="b">
                        <div className='modal-top-box'>
                            <div className='sub-box'>
                                <span>과거력 수정이 완료되었습니다.</span>
                            </div>
                        </div>
                        <div className="modal-bottom-box">                                
                            <div className='btn-layout'>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={handleClickSaveCompleteBtn}>
                                    <span>확인</span>
                                </button>
                            </div> 
                        </div>
                    </div>    
                </Modal>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default PastHistoryWrite;
